import React, { type ComponentProps, type ComponentType } from 'react';
import { I18nextProvider } from '@wix/yoshi-flow-editor';

export type AppI18n = ComponentProps<typeof I18nextProvider>['i18n'];

// Ricos renders plugin blocks under its own I18nextProvider, which shadows the widget's (one
// react-i18next module since pnpm). Memoise the result: a new component remounts.
export const withAppI18n = <P extends object>(
  Component: ComponentType<P>,
  i18n: AppI18n,
): ComponentType<P> => {
  const WithAppI18n = (props: P) => (
    <I18nextProvider i18n={i18n}>
      <Component {...props} />
    </I18nextProvider>
  );
  WithAppI18n.displayName = `WithAppI18n(${Component.displayName ?? Component.name})`;
  return WithAppI18n;
};
